// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__unRcd","activeLink":"navigation_activeLink__1LUK2","navigationDark":"navigation_navigationDark__2EMNU"};